export const ADDITIONAL_DETAILS_CREATE_APPOINTMENT = {
    details : [
        'hrLocation',
        'hrMobileNumber',
        'hrName',
        'AgentEmailId',
        'AgentName',
        'AgentContactNo',
        'ProposalNumber',
        'Entity',
        'CaseType',
        'Aadhar',
        'PAN',
        'packageOrGrade',
        'lifeNo',
        'clientLocation',
        'SMName',
        'SM_Email',
        'SMPhoneNumber'
    ]
} 